import React, { useCallback, useContext } from 'react';
import { Stack } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { $, StarberryComponentContext, useModule } from '@starberry/components';
import { Icon } from '@chakra-ui/react';

import * as AuthActions from 'core/services/store/auth/actions';
import AuthServices from 'core/services/store/auth/services';
import { InputField } from 'core/components/InputField';
import { AuthContext } from 'core/services/index';
import PasswordField from 'core/components/PasswordField';

import { Routes } from '../../routes';

function handleLoginError(errors) {
  switch (errors?.id) {
    case 'Auth.form.error.invalid':
      return 'Invalid email and password combination';
    default:
  }

  return errors?.message || 'Something went wrong';
}

const EmailIcon = (props) => {
  const { constants } = React.useContext(StarberryComponentContext);
  return <Icon as={constants.icons.emailInput} color="inherit" {...props} />;
};

function LoginForm() {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid, touchedFields },
  } = useForm({
    mode: 'onTouched',
    reValidateMode: 'onChange',
  });
  const globalContext = useContext(StarberryComponentContext);
  const [, dispatch] = useContext(AuthContext);

  const LoginSubmitButton = useModule('LoginSubmitButton');
  const ResetPassword = useModule('ResetPassword');

  const onSubmit = useCallback(
    (data) => {
      AuthServices(dispatch, AuthActions)
        .loginWithEmail(data)
        .then(() => {
          window.location.href = `${Routes[globalContext.constants.indexPage]}${
            window.location.search
          }`;
        })
        .catch((err) => {
          console.log('error', err);
        });
    },
    [dispatch, globalContext.constants.indexPage]
  );

  const emailInputProps = register('email', {
    required: 'Please enter your email',
    pattern: {
      value:
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      message: 'Invalid email address',
    },
  });
  const passwordInputProps = register('password', {
    required: 'Please enter your password',
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={6}>
        <InputField
          label={'Email Address'}
          name={'email'}
          type={'email'}
          autoComplete={'email'}
          required={true}
          rightIcon={EmailIcon}
          {...emailInputProps}
          error={errors.email}
        />
        <PasswordField
          label="Password"
          name="password"
          type="password"
          autoComplete="password"
          required={true}
          {...passwordInputProps}
          error={errors.password}
        />
        <ResetPassword />
        <LoginSubmitButton
          // disabled={
          //   // !touchedFields.email || !touchedFields.password || 
          //   !isValid
          // }
        />
      </Stack>
    </form>
  );
}

const LoginFormModule = {
  submitButton: {
    $: 'PrimaryButton',
    type: 'submit',
    children: $('constants.translations.login.LOGIN_SUBMIT_BTN', 'Continue'),
  },
  resetPassword: {
    $: 'WrappedLink',
    children: $('constants.translations.login.LOGIN_FORGOT_PASS', 'Forgot your password?'),
    props: {
      to: Routes.ResetPassEmailPage,
      textAlign: { base: 'left', md: 'right' },
      fontSize: '0.6875rem',
      color: '#53585c',
    },
  },

  children: [
    {
      $: 'Stack',
      props: {
        spacing: 0,
      },
      $children: [
        {
          $: 'Flex',
          provide: ['auth'],
          children: (_, context) => {
            const [state] = context?.state?.auth || [];
            if (!state?.message) {
              return [];
            }
            return {
              $: 'Alert',
              props: {
                status: 'error',
                display: state?.error ? 'flex' : 'none',
                mb: state?.error ? 6 : 0,
                borderRadius: $('constants.input.borderRadius'),
              },
              children: [
                { $: 'AlertIcon' },
                {
                  $: 'AlertTitle',
                  props: { mr: 2 },
                  children: handleLoginError(state?.message),
                },
              ],
            };
          },
        },
      ],
    },
    { component: LoginForm, LoginSubmitButton: $('submitButton'), ResetPassword: $('resetPassword') },
  ],
};

export default LoginFormModule;
